import IScope = angular.IScope;
require("./articlesTable.less");

class TableController {
    query ={
        limit: 100,
        page: 1,
        order: ''
    };
    filter = {
        filterText: "",
        active: false
    };
    tableDefinition;
    settings;
    columns;
    tableContent:Array<any>;
    urlListener;
    activeState;

    constructor(private $scope, private $location, private $state){
        $scope.query = this.query;
        this.urlListener = $scope.$on('$locationChangeSuccess', () => {
            this.setPaginationSettings();
        });
    }

    initiated;
    $onInit(){
        this.activeState = angular.copy(this.$state.current.name);
        this.setPaginationSettings();
        this.settings = this.tableDefinition.settings;
        this.columns = this.tableDefinition.columns;

        this.$scope.$watchCollection('query' , (newValue)=>{
            if(this.initiated && this.tableContent && this.activeState === this.$state.current.name){
                this.settings.onPaginate(newValue);
            }
            this.initiated = true;
        })
    }

    $onDestroy(){
        this.urlListener();
    }

    setPaginationSettings(){
        const queryParams = this.$location.search();
        this.query.limit = queryParams.pageSize ? parseInt(queryParams.pageSize) : 20;
        this.query.page = queryParams.pageNo ? parseInt(queryParams.pageNo) +1 : 1;
    }

    setFilterState(s) {
        this.filter.filterText = "";
        this.filter.active = s;
    }

    moveToArticleProfileForArticle(article: any){
        this.$state.go('loggedin.articles_articleprofile', {articleNo: article.articleNo});
    }
}

class ArticlesTableOptions implements ng.IComponentOptions {
    bindings: any = {
        tableContent:'=',
        tableDefinition:'='
    };
    controller: string = 'rkcArticlesTableController';
    controllerAs:string = 'c';
    template: any = require('./articlesTable.html');
}

rkcApp.controller("rkcArticlesTableController", ['$scope','$location','$state', function($scope, $location, $state){
    return new TableController($scope, $location, $state);
}])
    .component("rkcArticlesTable", new ArticlesTableOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/articles/articlesTable/articlesTable.ts
 **/